/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * PopulateEMR
 * OpenAPI spec version: v1
 */

export type SnapStates = typeof SnapStates[keyof typeof SnapStates];


export const SnapStates = {
  NotStarted: 'NotStarted',
  Transcribing: 'Transcribing',
  TranscriptionFailed: 'TranscriptionFailed',
  TranscriptionSucceeded: 'TranscriptionSucceeded',
  GeneratingNote: 'GeneratingNote',
  GenerateNoteFailed: 'GenerateNoteFailed',
  GenerateNoteSucceeded: 'GenerateNoteSucceeded',
} as const;
